// language.ts — which language the live coach speaks (the general-coach pivot,
// DIRECTION-GENERAL-SPEAKING.md). ANY language the model can handle: the customer
// types it, we never hardcode a supported list (Bogdan 2026-08-12 — "it should do
// any languages that the models can handle"). The suggestions below are a
// convenience shortcut, NOT a limit.
//
// The choice lives on the device and travels to the server only as the session's
// `language` field, which locks that call's coach prompt.
const KEY = "oriora.speaking.language.v1";
const RECENT_KEY = "oriora.speaking.language.recent.v1";

/** Shortcuts only — the field accepts anything the learner types. */
export const LANGUAGE_SUGGESTIONS = [
  "English", "Mandarin Chinese", "Spanish", "French", "German", "Italian",
  "Portuguese", "Japanese", "Korean", "Arabic", "Hindi", "Russian",
  "Dutch", "Polish", "Turkish", "Romanian", "Greek", "Swedish", "Vietnamese",
  "Thai", "Cantonese", "Ukrainian", "Czech", "Hebrew", "Indonesian", "Swahili",
  "Norwegian", "Danish", "Finnish", "Hungarian", "Bulgarian", "Serbian",
  "Catalan", "Tagalog", "Bengali", "Urdu", "Persian", "Malay",
];

export function getLanguage(): string {
  try { return localStorage.getItem(KEY) || "English"; } catch { return "English"; }
}

export function setLanguage(lang: string): void {
  const v = lang.trim().slice(0, 40);
  if (!v) return;
  try {
    localStorage.setItem(KEY, v);
    // Remember what this learner actually uses, so their own languages surface first.
    const prev = getRecentLanguages().filter((l) => l.toLowerCase() !== v.toLowerCase());
    localStorage.setItem(RECENT_KEY, JSON.stringify([v, ...prev].slice(0, 8)));
  } catch { /* storage full — the current call still uses it */ }
}

export function getRecentLanguages(): string[] {
  try {
    const raw = localStorage.getItem(RECENT_KEY);
    if (raw) { const p = JSON.parse(raw); if (Array.isArray(p)) return p.filter((x) => typeof x === "string"); }
  } catch { /* ignore */ }
  return [];
}

/** Suggestions with the learner's own recent choices first — for the datalist. */
export function languageOptions(): string[] {
  const recent = getRecentLanguages();
  const rest = LANGUAGE_SUGGESTIONS.filter((l) => !recent.some((r) => r.toLowerCase() === l.toLowerCase()));
  return [...recent, ...rest];
}
